import React from 'react';
import { map } from 'lodash';
import { connect } from 'react-redux';

import {
    DISPLAY_STEP,
    STATE_PENDING,
    STATE_VALID,
    STATE_INVALID
} from '../../../../constants/payment';
import { STATIC_ROOT } from '../../../../constants';
import { MOMENTJS_DATE_FORMAT_STANDARD } from '../../../../constants/moment';

import { fetchAccountPurchasesIfNeeded } from '../../../../services/account/cashback/actions';
import { toDate } from '../../../../utils/dateUtils';
import { formatAmount } from '../../../../utils/index';

import SvgComponent from '../../../SvgComponent';
import { LoadingComponent } from '../../../loading/LoadingComponent';
import ButtonComponent from '../../../../components/button/ButtonComponent';
import CashbackHistoryLegendComponent from './CashbackHistoryLegendComponent';

const renderPurchaseState = (icon, text, width, height) => (
    <td className="enteteTdTableBas">
        <SvgComponent src={`${STATIC_ROOT}/icon/picto-${icon}.svg`} width={width} height={height} />
        <span className="hidden-mobonly inbl stateTxt">{text}</span>
    </td>
);

class CashbackHistoryComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { index: DISPLAY_STEP };
    }

    handleSeeMoreClick() {
        this.setState({
            index: this.state.index + DISPLAY_STEP
        });
    }

    componentDidMount() {
        this.props.fetchAccountPurchasesIfNeeded();
    }

    renderConditionnalOnPurchaseState(purchaseState, paymentDate) {
        if (!purchaseState) return null;

        const i18n = this.props.i18n;

        if (purchaseState === STATE_VALID && paymentDate > 0) {
            return renderPurchaseState('paye', i18n.PAID, 17, 13);
        } else if (purchaseState === STATE_VALID) {
            return renderPurchaseState('valide', i18n.VALID, 17, 13);
        } else if (purchaseState === STATE_PENDING) {
            return renderPurchaseState('attente', i18n.WAITING, 17, 19);
        } else if (purchaseState === STATE_INVALID) {
            return renderPurchaseState('invalide', i18n.INVALID, 17, 15);
        }
    }

    renderSeeMoreButton(length, index, text, color) {
        if (length >= DISPLAY_STEP && index < length) {
            return (
                <div id="bt-voir-plusgains" className="txtcenter">
                    <ButtonComponent
                        type="button"
                        text={text}
                        color={color}
                        onClick={this.handleSeeMoreClick.bind(this)}
                    />
                </div>
            );
        }
    }

    render() {
        const { data, fetching, i18n } = this.props;

        return (
            <div className="historiqueAchat">
                <h3>{i18n.PURCHASE_HISTORY}</h3>
                <table className="table" id="historique-achat-table">
                    <thead>
                        <tr>
                            <th className="dateTh">{i18n.TH_DATE}</th>
                            <th className="marchandTh">{i18n.TH_MARCHAND}</th>
                            <th className="enteteTdTableBas gainsTh">{i18n.TH_GAINS}</th>
                            <th>
                                <span className="hidden-mobonly">{i18n.TH_ETAT}</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {!fetching &&
                            map(data.slice(0, this.state.index), purchase => (
                                <tr key={purchase.id}>
                                    <td className="enteteTdTableBas">
                                        {toDate(
                                            purchase.purchaseDate,
                                            MOMENTJS_DATE_FORMAT_STANDARD
                                        )}
                                    </td>
                                    <td className="enteteTdTableBas">{purchase.partnerName}</td>
                                    <td className="enteteTdTableBas opacite">
                                        {formatAmount(purchase.gain)}
                                    </td>
                                    {this.renderConditionnalOnPurchaseState(
                                        purchase.state,
                                        purchase.paymentDate
                                    )}
                                </tr>
                            ))}
                        {data && data.length === 0 && (
                            <tr>
                                <td className="empty" colSpan="4">
                                    {fetching ? <LoadingComponent /> : i18n.NO_PURCHASE}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                {this.renderSeeMoreButton(
                    data.length,
                    this.state.index,
                    i18n.SEE_MORE_GAIN,
                    'fifth'
                )}
                <CashbackHistoryLegendComponent />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT,
        fetching: state.account.mycashback.fetching,
        data: state.account.mycashback.purchases || []
    };
}

const mapDispatchToProps = {
    fetchAccountPurchasesIfNeeded
};

export default connect(mapStateToProps, mapDispatchToProps)(CashbackHistoryComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/CashbackHistoryComponent.js